enum FLOW_TYPE {
  ADVISORY = 'ADVISORY',
  RISKANALYSIS_NL = 'RISKANALYSIS_NL',
  RISKANALYSIS_BE = 'RISKANALYSIS_BE',
  RISKANALYSIS_BE_SHORT = 'RISKANALYSIS_BE_SHORT',
  COMPANY_SCAN = 'COMPANY_SCAN',
}

export default FLOW_TYPE;
